import { render, staticRenderFns } from "./toDosWidgetInstitutionLinkDialog.vue?vue&type=template&id=569d0ed8"
import script from "./toDosWidgetInstitutionLinkDialog.vue?vue&type=script&lang=ts"
export * from "./toDosWidgetInstitutionLinkDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports